import React from "react"
import { Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const showToastMessage = (message, showProgressBar, autoClose, messageId) => {
  if(messageId == null) {
    if(message && message.length > 0) {
      var toastId = toast.configure({
        transition: Slide,
        autoClose: autoClose,
        hideProgressBar: !showProgressBar,
        position: toast.POSITION.BOTTOM_CENTER
      });
      return toast(message);
    }
  } else {
    toast.update(messageId, {
      render: message,
      autoClose: autoClose,
      hideProgressBar: !showProgressBar
    });
    return messageId;
  }
}

export const dismissToastMessage = (messageId) => {
  toast.dismiss(messageId);
}
